import { render } from "./furo.vue?vue&type=template&id=f4da1dae&scoped=true"
import script from "./furo.vue?vue&type=script&lang=js"
export * from "./furo.vue?vue&type=script&lang=js"

import "./furo.vue?vue&type=style&index=0&id=f4da1dae&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4da1dae"]])

export default __exports__